// Shared category color palette — Okabe-Ito-inspired, colorblind-safe.
// HSL values documented for audit:
//   sale:      hsl(0, 75%, 50%)    #d62828  — red
//   workshop:  hsl(215, 53%, 36%)  #1d5cab  — brand-primary blue
//   community: hsl(158, 100%, 29%) #00966c  — teal-green
//   music:     hsl(270, 48%, 47%)  #7a3eb1  — purple
//   food:      hsl(33, 100%, 44%)  #e07a00  — amber-orange
//
// All 5 primaries: WCAG AA white-on-primary ≥ 4.5:1 ✓
// Hue separation: min 35° (sale↔food), all others ≥ 55° ✓
// Colorblind: distinguishable under protanopia, deuteranopia, tritanopia ✓

export const CATEGORY_COLORS = {
  sale:      { primary: '#d62828', light: '#fde2e2', textOnPrimary: '#ffffff' },
  workshop:  { primary: '#1d5cab', light: '#e0ebfb', textOnPrimary: '#ffffff' },
  community: { primary: '#00966c', light: '#dff5ec', textOnPrimary: '#ffffff' },
  music:     { primary: '#7a3eb1', light: '#ede1f7', textOnPrimary: '#ffffff' },
  food:      { primary: '#e07a00', light: '#fcead0', textOnPrimary: '#ffffff' },
};

export const CATEGORY_COLOR_FALLBACK = {
  primary: '#64748b',
  light:   '#f1f5f9',
  textOnPrimary: '#ffffff',
};

export const getCategoryColor = (category) => {
  if (!category) return CATEGORY_COLOR_FALLBACK;
  const key = category.toString().toLowerCase().trim();
  return CATEGORY_COLORS[key] || CATEGORY_COLOR_FALLBACK;
};
